import Vue from 'vue'
export default {
  onAppLaunch(vm) {
    Vue.prototype.$ORDER_STATUS = [
      'processing',
      'processed'
    ]
  }
}